import { useRef, useCallback, useEffect } from 'react';

const IDLE_SAVE_DELAY = 10000; // 10 sec
// Saves automatically after 10 sec of no edits
const useIdleAutoSave = ({ pendingChangesRef, performSave, view, isAuditFormOpen }) => {
  const idleTimerRef = useRef(null);

  const resetIdleTimer = useCallback(() => {
    if (idleTimerRef.current) clearTimeout(idleTimerRef.current);

    idleTimerRef.current = setTimeout(() => {
      if (view || isAuditFormOpen) return;

      const current = pendingChangesRef.current;
      const hasUnsaved =
        current.created.size > 0 ||
        current.updated.size > 0 ||
        current.deleted.size > 0;

      if (hasUnsaved) {
        performSave();
      }
    }, IDLE_SAVE_DELAY);
  }, [pendingChangesRef, performSave, view, isAuditFormOpen]);

  useEffect(() => {
    return () => {
      if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
    };
  }, []);

  return { resetIdleTimer };
};

export default useIdleAutoSave;